<template>
    <teleport to="head">
        <link rel="canonical" :href="$route.path" />
        <meta name="keywords" :content="metaKeyword">
        <meta name="description" :content="metaDescription">
        <meta name="author" content="HGSHYDRO">
        <meta name="publisher" content="HGSHYDRO">
    </teleport>
</template>

<script>
export default {
    name: 'CartSchemaJson',
    props: ['metaKeyword', 'metaDescription'],
    data() {
        return {
           cartMetaKeyword: "",
           cartMetaDescription: ""
        }
    },
    watch: {
        metaKeyword: {
            handler: function(metaKeyword) {
                this.cartMetaKeyword = metaKeyword;
            }
        },
        metaDescription: {
            handler: function(metaDescription) {
                this.cartMetaDescription = metaDescription;
            }
        }
    }
}   
</script>
